<template>
  <div>
    <h1>Certificate Merge</h1>
    <div class="card">
      <div class="card-header">Certificate merge</div>
      <div class="card-body">
        <b-row v-if="!selected1 || !selected2">
          <b-col>
            <div class="card">
              <div class="card-header">Certificate 1</div>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <BaseRadioInput v-model="searchBy1" :v="$v.searchBy1" label="Search by" :options="radioOptions"/>
                  </b-col>
                </b-row>
                <div class="searchBy1">
                  <b-row>
                    <b-col>
                      <BaseMaskedTextInput mask="###-##-####" v-if="searchBy1==='ssn'" label="Social Security Number" v-model="search1.ssn" :v="$v.search1.ssn" tip="###-##-####"/>
                      <BaseTextInput v-else-if="searchBy1==='email'" label="Account email" v-model="search1.email" :v="$v.search1.email"/>
                      <BaseMaskedTextInput mask="########" v-if="searchBy1==='number'" label="Certificate Number" v-model="search1.number" :v="$v.search1.number" tip="8 digits"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button variant="primary" @click="search(1)">Search</b-button>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="searchResults1">
                  <div v-for="(certificate, index) in searchResults1" v-bind:key="index">
                    <hr/>
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Full Name" :value="certificate.name"/>
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Certificate Number" :value="certificate.number"/>
<!--                        <button class="btn btn-primary" v-if="isAdmin() && certificate.number==null" @click="generateNumber(certificate.id)">Generate certificate number</button>-->
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Status" :value="certificate.status"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <BaseTextOutput label="Date of birth" :value="formatDate(certificate.dateOfBirth)"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <strong>Associated user account: </strong>
                        <a v-if=certificate.idmId :href="'/viewUser/'+certificate.idmId" target="_blank" class="btn btn-primary btn-sm">View</a>
                        <span v-else>No user account associated with this certificate</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <BaseTextOutput label="Complaints" :value="certificate.complaint?'SUBSTANTIATED':'NONE'"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Date Registered" :value="formatDate(certificate.approvedDate)"/>
                      </b-col>
                      <b-col cols="4" v-if="certificate.status === 'Inactive'">
                        <BaseTextOutput label="Inactive Date" :value="formatDate(certificate.expireDate)"/>
                      </b-col>
                      <b-col cols="4" v-if="certificate.status !== 'Inactive'">
                        <BaseTextOutput label="Expiration Date" :value="formatDate(certificate.expireDate)"/>
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Initial Date Registered" :value="formatDate(certificate.initialRegistryDate)"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="3">
                        <BaseTextOutput label="Most Recent Testing Date: Skill" :value="formatDate(certificate.skillTestDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Most Recent Testing Date: Knowledge" :value="formatDate(certificate.knowledgeTestDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Last Training Date*" :value="formatDate(certificate.trainingDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Test-out Candidate Only" :value="certificate.testOut"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="9">
                        <BaseTextOutput label="Address" :value="certificate.streetAddress+', '+certificate.city+', '+certificate.state+' '+certificate.zip"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Phone#" :value="certificate.phoneNumber"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-button variant="primary" @click="select(1, certificate)" :disabled="!!selected1">Select</b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </b-col>

          <b-col>
            <div class="card">
              <div class="card-header">Certificate 2</div>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <BaseRadioInput v-model="searchBy2" :v="$v.searchBy2" label="Search by" :options="radioOptions"/>
                  </b-col>
                </b-row>
                <div class="searchBy2">
                  <b-row>
                    <b-col>
                      <BaseMaskedTextInput mask="###-##-####" v-if="searchBy2==='ssn'" label="Social Security Number" v-model="search2.ssn" :v="$v.search2.ssn" tip="###-##-####"/>
                      <BaseTextInput v-else-if="searchBy2==='email'" label="Account email" v-model="search2.email" :v="$v.search2.email"/>
                      <BaseMaskedTextInput mask="########" v-if="searchBy2==='number'" label="Certificate Number" v-model="search2.number" :v="$v.search2.number" tip="8 digits"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button variant="primary" @click="search(2)">Search</b-button>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="searchResults2">
                  <div v-for="(certificate, index) in searchResults2" v-bind:key="index">
                    <hr/>
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Full Name" :value="certificate.name"/>
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Certificate Number" :value="certificate.number"/>
                        <!--                        <button class="btn btn-primary" v-if="isAdmin() && certificate.number==null" @click="generateNumber(certificate.id)">Generate certificate number</button>-->
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Status" :value="certificate.status"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <BaseTextOutput label="Date of birth" :value="formatDate(certificate.dateOfBirth)"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <strong>Associated user account: </strong>
                        <a v-if=certificate.idmId :href="'/viewUser/'+certificate.idmId" target="_blank" class="btn btn-primary btn-sm">View</a>
                        <span v-else>No user account associated with this certificate</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <BaseTextOutput label="Complaints" :value="certificate.complaint?'SUBSTANTIATED':'NONE'"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Date Registered" :value="formatDate(certificate.approvedDate)"/>
                      </b-col>
                      <b-col cols="4" v-if="certificate.status === 'Inactive'">
                        <BaseTextOutput label="Inactive Date" :value="formatDate(certificate.expireDate)"/>
                      </b-col>
                      <b-col cols="4" v-if="certificate.status !== 'Inactive'">
                        <BaseTextOutput label="Expiration Date" :value="formatDate(certificate.expireDate)"/>
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput label="Initial Date Registered" :value="formatDate(certificate.initialRegistryDate)"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="3">
                        <BaseTextOutput label="Most Recent Testing Date: Skill" :value="formatDate(certificate.skillTestDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Most Recent Testing Date: Knowledge" :value="formatDate(certificate.knowledgeTestDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Last Training Date*" :value="formatDate(certificate.trainingDate)"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Test-out Candidate Only" :value="certificate.testOut"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="9">
                        <BaseTextOutput label="Address" :value="certificate.streetAddress+', '+certificate.city+', '+certificate.state+' '+certificate.zip"/>
                      </b-col>
                      <b-col cols="3">
                        <BaseTextOutput label="Phone#" :value="certificate.phoneNumber"/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-button variant="primary" @click="select(2, certificate)" :disabled="!!selected2">Select</b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          
          
        </b-row>
<!--        <div v-else-if="selected1.id === selected2.id">-->
<!--          Same certificate selected twice.-->
<!--        </div>-->
        <div v-else>
          <h3>Select differences:</h3>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.lastName" label="Last name" :value="merged.lastName"/>
              <BaseRadioInput v-else label="Last name" v-model="merged.lastName" :v="$v.merged.lastName" :options="lastNameOptions" @input="ticked.lastName=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.firstName" label="First name" :value="merged.firstName"/>
              <BaseRadioInput v-else label="First name" v-model="merged.firstName" :v="$v.merged.firstName" :options="firstNameOptions" @input="ticked.firstName=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.middleName" label="Middle name" :value="merged.middleName?merged.middleName:'(blank)'"/>
              <BaseRadioInput v-else label="Middle name" v-model="merged.middleName" :v="$v.merged.middleName" :options="middleNameOptions" @input="ticked.middleName=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.dateOfBirth" label="Date of birth" :value="formatDate(merged.dateOfBirth)"/>
              <BaseRadioInput v-else label="Date of birth" v-model="merged.dateOfBirth" :v="$v.merged.dateOfBirth" :options="dateOfBirthOptions" @input="ticked.dateOfBirth=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput label="Status" :value="statusCalc"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput label="Complaints" :value="complaintCalc"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.number" label="Certificate number" :value="merged.number?merged.number:'(blank)'"/>
              <BaseRadioInput v-else label="Certificate number" v-model="merged.number" :v="$v.merged.number" :options="numberOptions" @input="ticked.number=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.ssn" label="SSN" :value="merged.ssn"/>
              <BaseRadioInput v-else label="SSN" v-model="merged.ssn" :v="$v.merged.ssn" :options="ssnOptions" @input="ticked.ssn=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.email" label="User Account Email" :value="merged.email.email?merged.email.email:'No account associated'"/>
              <BaseRadioInput v-else label="User Account Email" v-model="merged.email" :v="$v.merged.email" :options="emailOptions" @input="ticked.email=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.initialRegistryDate" label="Initial date registered" :value="formatDate(merged.initialRegistryDate)"/>
              <BaseRadioInput v-else label="Initial date registered" v-model="merged.initialRegistryDate" :v="$v.merged.initialRegistryDate" :options="initialRegistryDateOptions" @input="ticked.initialRegistryDate=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.skillTestDate" label="Most recent skill test date" :value="formatDate(merged.skillTestDate)"/>
              <BaseRadioInput v-else label="Most recent skill test date" v-model="merged.skillTestDate" :v="$v.merged.skillTestDate" :options="skillTestDateOptions" @input="ticked.skillTestDate=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.knowledgeTestDate" label="Most recent knowledge test date" :value="formatDate(merged.knowledgeTestDate)"/>
              <BaseRadioInput v-else label="Most recent knowledge test date" v-model="merged.knowledgeTestDate" :v="$v.merged.knowledgeTestDate" :options="knowledgeTestDateOptions" @input="ticked.knowledgeTestDate=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.trainingDate" label="Last training date" :value="formatDate(merged.trainingDate)"/>
              <BaseRadioInput v-else label="Last training date" v-model="merged.trainingDate" :v="$v.merged.trainingDate" :options="trainingDateOptions" @input="ticked.trainingDate=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.testOut" label="Test out" :value="!!merged.testOut?'Yes':'No'"/>
              <BaseRadioInput v-else label="Test out" v-model="merged.testOut" :v="$v.merged.testOut"  :options="testOutOptions" @input="ticked.testOut=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.address" label="Address" :value="merged.address.streetAddress+', '+merged.address.city+', '+merged.address.state+' '+merged.address.zip"/>
              <BaseRadioInput v-else label="Address" v-model="merged.address" :v="$v.merged.address" :options="addressOptions" @input="ticked.address=true"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseTextOutput v-if="same.phoneNumber" label="Phone number" :value="merged.phoneNumber"/>
              <BaseRadioInput v-else label="Phone number" v-model="merged.phoneNumber" :v="$v.merged.phoneNumber" :options="phoneNumberOptions" @input="ticked.phoneNumber=true"/>
            </b-col>
          </b-row>
<!--          <b-row>-->
<!--            <b-col>-->
<!--              <b-button variant="warning" @click="print()">Print merge object</b-button>-->
<!--            </b-col>-->
<!--          </b-row>-->
          <b-row>
            <b-col>
              <b-button variant="primary" :disabled = "submitted" @click="submit()">Submit</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import BaseRadioInput from "@/components/templates/input/BaseRadioInput.vue";
import {email, minLength, required, requiredIf} from "vuelidate/lib/validators";
import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput.vue";
import BaseTextOutput from "@/components/templates/input/BaseTextOutput.vue";
import moment from "moment";
import axios from "axios";

export default {
  name: "CertificateMerge",
  components: {BaseTextOutput, BaseMaskedTextInput, BaseRadioInput, BaseTextInput},
  data: ()=>({
    searchBy1: null,
    searchBy2: null,
    radioOptions: [
      {value: 'email', text: 'Account Email'},
      {value: 'ssn', text: 'SSN'},
      {value: 'number', text: 'Certificate Number'}
    ],
    search1:{
      ssn: null,
      email: null,
      number: null
    },
    search2:{
      ssn: null,
      email: null,
      number: null
    },
    searchResults1: null,
    searchResults2: null,
    selected1: null,
    selected2: null,
    merged: {
      lastName: null,
      firstName: null,
      middleName: null,
      number: null,
      ssn: null,
      email: null,
      initialRegistryDate: null,
      skillTestDate: null,
      knowledgeTestDate: null,
      trainingDate: null,
      testOut: null,
      dateOfBirth: null,
      address: null,
      phoneNumber: null,
    },
    ticked: {
      lastName: null,
      firstName: null,
      middleName: null,
      number: null,
      ssn: null,
      email: null,
      initialRegistryDate: null,
      skillTestDate: null,
      knowledgeTestDate: null,
      trainingDate: null,
      testOut: null,
      dateOfBirth: null,
      address: null,
      phoneNumber: null,
    },
    same: {
      lastName: null,
      firstName: null,
      middleName: null,
      number: null,
      email: null,
      initialRegistryDate: null,
      skillTestDate: null,
      knowledgeTestDate: null,
      trainingDate: null,
      testOut: null,
      dateOfBirth: null,
      address: null,
      phoneNumber: null,
    },
    submitted: false
  }),
  methods: {
    formatDate(unformattedDate){
      let formattedDate = moment(unformattedDate);
      if(!formattedDate.isValid()) return 'n/a';
      return formattedDate.format("MM/DD/YYYY")
    },
    search(selection){
      this.$v.$reset();
      let payload;
      switch (selection){
        case 1:
          this.$v.searchBy1.$touch();
          this.$v.search1.$touch();
          if(this.$v.searchBy1.$error || this.$v.search1.$error){
            return;
          }
          switch(this.searchBy1){
            case "ssn":
              payload = {ssn: this.search1.ssn};
              break;
            case "number":
              payload = {number: this.search1.number};
              break;
            case "email":
              payload = {email: this.search1.email};
              break; 
          }
          break;

        case 2:
          this.$v.searchBy2.$touch();
          this.$v.search2.$touch();
          if(this.$v.searchBy2.$error || this.$v.search2.$error){
            return;
          }
          switch(this.searchBy2){
            case "ssn":
              payload = {ssn: this.search2.ssn};
              break;
            case "number":
              payload = {number: this.search2.number};
              break;
            case "email":
              payload = {email: this.search2.email};
              break;
          }
          break;

      }
      payload.page = 1;
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/mergeSearch`, payload)
          .then(response => {
            switch(selection){
              case 1:
                this.searchResults1 = response.data;
                break;
              case 2:
                this.searchResults2 = response.data;
                break;
            }
          })


    },
    select(selection, certificate){
      if(selection === 1){
        this.selected1 = certificate;
      }
      else if(selection === 2){
        this.selected2 = certificate;
      }
      console.log(this.selected1);
      console.log(this.selected2);
      if(this.selected1 && this.selected2){
        if(this.selected1.lastName === this.selected2.lastName){
          this.same.lastName=true;
          this.ticked.lastName=true;
          this.merged.lastName=this.selected1.lastName;
        }
        if(this.selected1.firstName === this.selected2.firstName){
          this.same.firstName=true;
          this.ticked.firstName=true;
          this.merged.firstName=this.selected1.firstName;
        }
        if(this.selected1.middleName === this.selected2.middleName || (this.isEmptyOrSpaces(this.selected1.middleName) && this.isEmptyOrSpaces(this.selected2.middleName))){
          this.same.middleName=true;
          this.ticked.middleName=true;
          this.merged.middleName=this.selected1.middleName;
        }
        if(this.selected1.number === this.selected2.number){
          this.same.number=true;
          this.ticked.number=true;
          this.merged.number=this.selected1.number;
        }
        if(this.selected1.ssn===this.selected2.ssn){
          this.same.ssn=true;
          this.ticked.ssn=true;
          this.merged.ssn=this.selected1.ssn;
        }
        if(this.selected1.email===this.selected2.email){
          this.same.email=true;
          this.ticked.email=true;
          this.merged.email= {idmId: this.selected1.idmId, email: this.selected1.email};
        }
        if(this.selected1.initialRegistryDate===this.selected2.initialRegistryDate){
          this.same.initialRegistryDate=true;
          this.ticked.initialRegistryDate=true;
          this.merged.initialRegistryDate=this.selected1.initialRegistryDate;
        }
        if(this.selected1.skillTestDate===this.selected2.skillTestDate){
          this.same.skillTestDate=true;
          this.ticked.skillTestDate=true;
          this.merged.skillTestDate=this.selected1.skillTestDate;
        }
        if(this.selected1.knowledgeTestDate===this.selected2.knowledgeTestDate){
          this.same.knowledgeTestDate=true;
          this.ticked.knowledgeTestDate=true;
          this.merged.knowledgeTestDate=this.selected1.knowledgeTestDate;
        }
        if(this.selected1.trainingDate===this.selected2.trainingDate){
          this.same.trainingDate=true;
          this.ticked.trainingDate=true;
          this.merged.trainingDate=this.selected1.trainingDate;
        }
        if(!!this.selected1.testOut === !!this.selected2.testOut){
          this.same.testOut=true;
          this.ticked.testOut=true;
          this.merged.testOut=!!this.selected1.testOut;
        }
        if(this.selected1.streetAddress === this.selected2.streetAddress &&
        this.selected1.city === this.selected2.city && this.selected1.state === this.selected2.state && this.selected1.zip === this.selected2.zip){
          this.same.address=true;
          this.ticked.address=true;
          this.merged.address={
            streetAddress: this.selected1.streetAddress,
            city: this.selected1.city,
            state: this.selected1.state,
            zip: this.selected1.zip
          };
        }
        if(this.selected1.phoneNumber===this.selected2.phoneNumber && this.selected1.textingPreferences === this.selected2.textingPreferences){
          this.same.phoneNumber=true;
          this.ticked.phoneNumber=true;
          this.merged.phoneNumber={
            phoneNumber: this.selected1.phoneNumber,
            textingPreferences: this.selected1.textingPreferences
          };
        }
        if(this.selected1.dateOfBirth===this.selected2.dateOfBirth){
          this.same.dateOfBirth=true;
          this.ticked.dateOfBirth=true;
          this.merged.dateOfBirth=this.selected1.dateOfBirth;
        }
      }
    },
    isEmptyOrSpaces(str) {
      // First check for null/undefined to prevent errors when calling .trim()
      return str == null || (typeof str === 'string' && str.trim().length === 0);
    },
    print(){
      console.log(this.merged);
      console.log(this.ticked);
      console.log(this.same);
    },
    submit(){
        this.submitted=true;
        for(const [key, value] of Object.entries(this.ticked)){
          if(!value){
            this.showRootToast('Missing selection', '1 or more cherrypick selections are missing', 'warning');
            this.submitted=false;
            return;
          }
        }
        let payload = Object.assign({}, this.merged);
        payload.certId1=this.selected1.id;
        payload.certId2=this.selected2.id;

        console.log(payload);

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/merge`, payload)
            .then(response => {
              this.$nextTick(()=>{
                this.showRootToast('Certificates merged','Certs were successfully merged','success')
              })
              this.reset();
            })
            .catch(error =>
              this.showRootToast('Certificate merge failed', JSON.stringify(error), 'danger')
            )
            .finally(()=>{
              this.submitted=false;
            })
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
    reset(){
      this.searchBy1=null;
      this.searchBy2=null;

      this.search1={
        ssn: null,
            email: null,
            number: null
      };
      this.search2={
        ssn: null,
            email: null,
            number: null
      };
      this.searchResults1=null;
      this.searchResults2=null;
      this.selected1=null;
      this.selected2=null;
      this.merged={
        lastName: null,
            firstName: null,
            middleName: null,
            number: null,
            ssn: null,
            email: null,
            initialRegistryDate: null,
            skillTestDate: null,
            knowledgeTestDate: null,
            trainingDate: null,
            testOut: null,
            dateOfBirth: null,
            address: null,
            phoneNumber: null,
      };
      this.ticked={
        lastName: null,
            firstName: null,
            middleName: null,
            number: null,
            ssn: null,
            email: null,
            initialRegistryDate: null,
            skillTestDate: null,
            knowledgeTestDate: null,
            trainingDate: null,
            testOut: null,
            dateOfBirth: null,
            address: null,
            phoneNumber: null,
      };
      this.same={
        lastName: null,
            firstName: null,
            middleName: null,
            number: null,
            email: null,
            initialRegistryDate: null,
            skillTestDate: null,
            knowledgeTestDate: null,
            trainingDate: null,
            testOut: null,
            dateOfBirth: null,
            address: null,
            phoneNumber: null,
      };
    }
  },
  computed: {
    lastNameOptions: function(){
      return [
        {value: this.selected1.lastName, text: this.selected1.lastName},
        {value: this.selected2.lastName, text: this.selected2.lastName}
      ]
    },
    firstNameOptions: function(){
      return [
        {value: this.selected1.firstName, text: this.selected1.firstName},
        {value: this.selected2.firstName, text: this.selected2.firstName}
      ]
    },
    middleNameOptions: function(){
      return [
        {value: this.selected1.middleName?this.selected1.middleName:'', text: this.selected1.middleName?this.selected1.middleName:'(blank)'},
        {value: this.selected2.middleName?this.selected2.middleName:'', text: this.selected2.middleName?this.selected2.middleName:'(blank)'}
      ]
    },
    statusCalc: function(){
      if(this.selected1.status === 'Active' || this.selected2.status === 'Active'){
        return "Merging at least 1 active certificate, result will be active";
      }
      return "Merging 2 inactive certificates, result will be inactive";
    },
    complaintCalc: function(){
      if(this.selected1.complaint || this.selected2.complaint){
        return "Merging at least 1 certificate with substantiated complaints, result will be marked as having a substantiated complaint";
      }
      return "Merging 2 certificates with no substantiated complaints, result will be marked as having no complaints";
    },
    numberOptions: function(){
      return [
        {value: this.selected1.number?this.selected1.number:'', text: this.selected1.number?this.selected1.number:'(blank)'},
        {value: this.selected2.number?this.selected2.number:'', text: this.selected2.number?this.selected2.number:'(blank)'}
      ]
    },
    ssnOptions: function(){
      return [
        {value: this.selected1.ssn, text:this.selected1.ssn},
        {value: this.selected2.ssn, text:this.selected2.ssn}
      ]
    },
    emailOptions: function(){
      return [
        {value: {idmId: this.selected1.idmId, email: this.selected1.email}, text: this.selected1.email?this.selected1.email:'No account associated'},
        {value: {idmId: this.selected2.idmId, email: this.selected2.email}, text: this.selected2.email?this.selected2.email:'No account associated'}
      ]
    },
    initialRegistryDateOptions: function(){
      return [
        {value: this.selected1.initialRegistryDate?this.selected1.initialRegistryDate:'', text: this.formatDate(this.selected1.initialRegistryDate)},
        {value: this.selected2.initialRegistryDate?this.selected2.initialRegistryDate:'', text: this.formatDate(this.selected2.initialRegistryDate)}
      ]
    },
    skillTestDateOptions: function(){
      return [
        {value: this.selected1.skillTestDate?this.selected1.skillTestDate:'', text: this.formatDate(this.selected1.skillTestDate)},
        {value: this.selected2.skillTestDate?this.selected2.skillTestDate:'', text: this.formatDate(this.selected2.skillTestDate)}
      ]
    },
    knowledgeTestDateOptions: function(){
      return [
        {value: this.selected1.knowledgeTestDate?this.selected1.knowledgeTestDate:'', text: this.formatDate(this.selected1.knowledgeTestDate)},
        {value: this.selected2.knowledgeTestDate?this.selected2.knowledgeTestDate:'', text: this.formatDate(this.selected2.knowledgeTestDate)}
      ]
    },
    trainingDateOptions: function(){
      return [
        {value: this.selected1.trainingDate?this.selected1.trainingDate:'', text: this.formatDate(this.selected1.trainingDate)},
        {value: this.selected2.trainingDate?this.selected2.trainingDate:'', text: this.formatDate(this.selected2.trainingDate)}
      ]
    },
    testOutOptions: function(){
      return [
        {value: !!this.selected1.testOut, text: this.selected1.testOut?'Yes':'No'},
        {value: !!this.selected2.testOut, text: this.selected2.testOut?'Yes':'No'}
      ]
    },
    addressOptions: function(){
      return [
        {
          value: {
            streetAddress: this.selected1.streetAddress,
            city: this.selected1.city,
            state: this.selected1.state,
            zip: this.selected1.zip
          },
        text: this.selected1.streetAddress+", "+this.selected1.city+", "+this.selected1.state+" "+this.selected1.zip
        },
        {
          value: {
            streetAddress: this.selected2.streetAddress,
            city: this.selected2.city,
            state: this.selected2.state,
            zip: this.selected2.zip
          },
          text: this.selected2.streetAddress+", "+this.selected2.city+", "+this.selected2.state+" "+this.selected2.zip
        },
      ]
    },
    phoneNumberOptions:function (){return [
      {value:
            {
              phoneNumber: this.selected1.phoneNumber,
              textingPreferences: this.selected1.textingPreferences
            }, text: this.selected1.phoneNumber+", "+this.selected1.textingPreferences},
      {value:
            {
              phoneNumber: this.selected2.phoneNumber,
              textingPreferences: this.selected2.textingPreferences
            }, text: this.selected2.phoneNumber+", "+this.selected2.textingPreferences}
    ]},
    dateOfBirthOptions: function(){
      return [
        {value: this.selected1.dateOfBirth, text: this.formatDate(this.selected1.dateOfBirth)},
        {value: this.selected2.dateOfBirth, text: this.formatDate(this.selected2.dateOfBirth)}
      ]
    }
  },
  validations(){
    return{
      searchBy1: {required},
      searchBy2: {required},
      search1: {
        ssn: {
          required: requiredIf(function(){return this.searchBy1==='ssn'}),
          minLength: minLength(11),
        },
        number: {
          required: requiredIf(function(){return this.searchBy1==='number'}),
          minLength: minLength(8),
        },
        email: {
          required: requiredIf(function(){return this.searchBy1==='email'}),
          email
        }
      },
      search2: {
        ssn: {
          required: requiredIf(function(){return this.searchBy2==='ssn'}),
          minLength: minLength(11),
        },
        number: {
          required: requiredIf(function(){return this.searchBy2==='number'}),
          minLength: minLength(8),
        },
        email: {
          required: requiredIf(function(){return this.searchBy2==='email'}),
          email
        }
      },
      merged: {
        lastName: {required: false},
        firstName: {required: false},
        middleName: {required: false},
        number: {required: false},
        ssn: {required: false},
        dateOfBirth: {required: false},
        email: {required: false},
        initialRegistryDate: {required: false},
        skillTestDate: {required: false},
        knowledgeTestDate: {required: false},
        trainingDate: {required: false},
        testOut: {required: false},
        address: {required: false},
        phoneNumber: {required: false}
      }
    }
  }
}
</script>

<style scoped>

</style>